import { ConductSelectTypesFilterValue, ConductType, FilterKeys } from '@schooly/api';

import { toggleArrayProperty } from '../PersonalFilters/PersonalFilterModal';

type FiltersWithConductTypeAndConductSelectType = {
  [FilterKeys.ConductSelectTypes]?: ConductSelectTypesFilterValue[];
  [FilterKeys.ConductType]?: string[];
};

export const applySelectedConductTypeId =
  (conductTypeId: string) =>
  <T extends FiltersWithConductTypeAndConductSelectType>(filters: T) => {
    return {
      ...filters,
      [FilterKeys.ConductSelectTypes]: filters[FilterKeys.ConductSelectTypes]?.filter(
        (o) => o.conduct_type_id !== conductTypeId,
      ),
      [FilterKeys.ConductType]: toggleArrayProperty(filters[FilterKeys.ConductType], conductTypeId),
    };
  };

export const applySelectedConductTypeOption =
  (conductTypeId: string, option: string) =>
  <T extends FiltersWithConductTypeAndConductSelectType>(filters: T) => {
    const existingOptions = filters.conduct_select_types ?? [];
    const existingEntry = existingOptions.find((entry) => entry.conduct_type_id === conductTypeId);

    const updatedConductType = filters.conduct_type?.includes(conductTypeId)
      ? filters.conduct_type?.filter((id) => id !== conductTypeId)
      : filters.conduct_type;

    let updatedSelectTypes;

    if (existingEntry) {
      updatedSelectTypes = existingOptions.map((entry) =>
        entry.conduct_type_id === conductTypeId
          ? {
              conduct_type_id: entry.conduct_type_id,
              conduct_type_options: toggleArrayProperty(entry.conduct_type_options, option),
            }
          : entry,
      );
    } else {
      updatedSelectTypes = [
        ...existingOptions,
        {
          conduct_type_id: conductTypeId,
          conduct_type_options: [option],
        },
      ];
    }

    return {
      ...filters,
      [FilterKeys.ConductSelectTypes]: updatedSelectTypes.filter(
        (o) => o.conduct_type_options.length,
      ),
      [FilterKeys.ConductType]: updatedConductType,
    };
  };

export const onSelectConductTypeOrConductTypeOption =
  ({
    conductTypes,
    selectedConductTypeOptions,
    onSelectConductTypeId,
    onSelectConductTypeOption,
  }: {
    conductTypes: ConductType[] | undefined;
    selectedConductTypeOptions: ConductSelectTypesFilterValue[];
    onSelectConductTypeId: (id: string) => void;
    onSelectConductTypeOption: (conductTypeId: string, option: string) => void;
  }) =>
  (conductTypeId: string, option: string) => {
    const relatedConductType = conductTypes?.find((cd) => cd.id === conductTypeId);
    const conductTypeOptionsCount = (relatedConductType?.select_type_options ?? []).length;
    const selectedOptions = selectedConductTypeOptions.find(
      (option) => option.conduct_type_id === relatedConductType?.id,
    )?.conduct_type_options;
    const selectedOptionsCount = (selectedOptions?.length ?? 0) + 1;

    if (
      relatedConductType &&
      selectedOptionsCount === conductTypeOptionsCount &&
      !selectedOptions?.includes(option)
    ) {
      onSelectConductTypeId(relatedConductType.id);
      return;
    }

    onSelectConductTypeOption(conductTypeId, option);
  };
